export const ADD_MOVIE_TO_WATCHLIST = "ADD_MOVIE_TO_WATCHLIST";
export const REMOVE_MOVIE_FROM_WATCHLIST = "REMOVE_MOVIE_FROM_WATCHLIST";
export const ADD_MOVIE_WATCHED = "ADD_MOVIE_WATCHED";
export const REMOVE_MOVIE_FROM_WATCHED = "REMOVE_MOVIE_FROM_WATCHED";
export const MOVE_MOVIE_FROM_WATCHED_TO_WATCHLIST =
  "MOVE_MOVIE_FROM_WATCHED_TO_WATCHLIST";
